import { CSSProperties } from "react";
import { TableColumn, TableDataType } from "../../types/Table/TableColumns";

interface TableDataProps {
  row: any;
  column: TableColumn;
}

const TableData = ({ row, column }: TableDataProps) => {
  const cellStyle: CSSProperties = {
    maxWidth: column.maxWidth != null ? column.maxWidth : undefined,
    minWidth: column.minWidth != null ? column.minWidth : undefined,
    overflowX: "clip" as "clip",
  };  

  const RenderData = (row: any, column: TableColumn) => {
    // Use custom renderer if provided
    if (column.renderContents) {
      return column.renderContents(row[column.field], row);
    }

    // Fall back to default rendering logic
    switch (column.dataType) {
      case TableDataType.LINK:
        return (
          <a href={row[column.field]} target="_blank">
            {row[column.field]}
          </a>
        );
      case TableDataType.DATE:
        return row[column.field]?.toFormat(column.dateFormat);
      default:
        return row[column.field];
    }
  };

  return <td style={cellStyle}>{RenderData(row, column)}</td>;
};

export default TableData;
